import { render, staticRenderFns } from "./total-unpaid-and-income-by-fee.vue?vue&type=template&id=5005abf2&scoped=true&"
import script from "./total-unpaid-and-income-by-fee.vue?vue&type=script&lang=js&"
export * from "./total-unpaid-and-income-by-fee.vue?vue&type=script&lang=js&"
import style0 from "./total-unpaid-and-income-by-fee.vue?vue&type=style&index=0&id=5005abf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005abf2",
  null
  
)

export default component.exports